import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { withApiKey } from '@/app/helpers/auth.context';
import { Observable, of, shareReplay, tap } from 'rxjs';

export interface CountryLocation {
  ip: string;
  country: string;
  countryCode: string;
  city: string;
  region: string;
  data?: any;
}

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private http = inject(HttpClient);
  private cached?: CountryLocation;
  private pending$?: Observable<CountryLocation>;

  /** Performs the HTTP call only once, then serves cached value */
  getCountry(): Observable<CountryLocation> {
    if (this.cached) {
      return of(this.cached);
    }
    if (!this.pending$) {
      this.pending$ = this.http.get<CountryLocation>('/ip/country', { context: withApiKey() }).pipe(
        tap((loc) => (this.cached = loc)),
        shareReplay(1),
      );
    }
    return this.pending$;
  }
}
